const {
  appendPath,
  getContentValue,
  keysSortedByValueAscending
} = require('@truqc/content-path');
const {
  getFormContent
} = require('../lib/getFormContent');

/**
  * Returns an error message if the selected asset has any warning note(s) attached.
  *
  * @function evaluate - evaluate ucbWarningNotesErrorTextBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const warningNotes = [];
  const asset = getContentValue(appendPath(parentContentPath, 'asset'), content) || {};
  const formIDs = Object.keys(asset);
  for (let i = 0; i < formIDs.length; i += 1) {
    const formID = formIDs[i];
    // eslint-disable-next-line no-await-in-loop
    const formContent = await getFormContent(formID, content, parentContentPath, transientContext, nativeFunctions);
    const {
      alertNotes = {}
    } = formContent;
    keysSortedByValueAscending(alertNotes).forEach(key => {
      const value = alertNotes[key];
      const {
        alertNote
      } = value;
      if (alertNote !== undefined) {
        warningNotes.push(alertNote);
      }
    });
  }
  return warningNotes.length > 0 ? warningNotes.join('\n') : undefined;
};
module.exports = {
  evaluate
};